export default {
    duration: {
        short: 100,
        regular: 250,
        long: 500,
    },
};
